import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/common-models';
import { MyErrorStateMatcher } from '../../models/error-matcher';

@Component({
  selector: 'app-form-textarea',
  templateUrl: './form-textarea.component.html',
  styleUrls: ['./form-textarea.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FormTextareaComponent implements Field, OnInit {
  config: FieldConfig;
  group: FormGroup;
  FormControlName: string;
  constructor() { }
  matcher = new MyErrorStateMatcher();
  
  ngOnInit() {
    this.FormControlName = this.config.name;
  }

}
